module.exports = __webpack_public_path__ + "static/media/muzej.5b5cbca6.jpg";